import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=8ceaa084&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"
import style0 from "./Icons.vue?vue&type=style&index=0&id=8ceaa084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ceaa084",
  null
  
)

export default component.exports